import './AitTClassLegend.scss';

import React from 'react';

import ToolTip from 'src/component/UI/ToolTip';
import { useTranslation } from 'src/i18n';
import { T_CLASS_RATINGS } from 'src/utils/miSetpointCalculator';

/**
 * Help tooltip shown next to the Auto-Ignition Temp (AIT) field. It explains
 * how the Area Temperature Rating is derived — the highest T-class rating
 * strictly below the AIT — and lists the full T-class legend so the operator
 * can see the mapping. Reuses the shared T_CLASS_RATINGS table so the legend
 * can never drift from the value the safety calculator actually uses.
 */
export default function AitTClassLegend () {
  const { t } = useTranslation();

  return (
    <ToolTip helpText={
      <div className='t-class-legend'>
        <div className='t-class-legend__intro'>{t('device.aitTClassLegend')}</div>
        <table className='t-class-legend__table'>
          <thead>
            <tr>
              <th>{t('device.aitTClassLegendClass')}</th>
              <th>{t('device.aitTClassLegendRating')}</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(T_CLASS_RATINGS).map(([tClass, rating]) => (
              <tr key={tClass}>
                <td>{tClass}</td>
                <td>{rating}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    } />
  );
}
